import React from 'react';
import Logo from 'assets/images/med-x-logo-footer.png';

export const Footer = () => {
  return (
    <div className="bg-gradient_footer mt-3">
      <div className="flex items-center justify-between px-4 py-6 text-xs font-semibold ">
        <div className="flex items-center space-x-2">
          <img src={Logo} alt="MedX" className="h-9 w-10" />
          <div className="flex flex-col justify-center">
            <h5 className="text-[#50AF50]">MedX.vn</h5>
            <p>Nền tảng học tập Y khoa toàn diện</p>
          </div>
        </div>
        <p>
          <a href="https://www.medx.vn/register" className="text-[#50AF50]">
            ĐĂNG KÝ NGAY
          </a>
        </p>
      </div>
    </div>
  );
};
